import React from 'react';
import { css as reactCss } from '@emotion/react';
import { colors } from '~src/main/theme/colors';
import { useGlobalState } from '~src/main/context/global-state';

export const WidgetLayout: React.FC = props => {
  const globalState = useGlobalState();

  return <div css={styles.widget(!!globalState?.flags?.enable_widget_border)} {...props} />;
};

const styles = {
  widget: (enable_widget_border: boolean) =>
    reactCss({
      width: '100%',
      padding: '24px 16px',
      border: enable_widget_border ? `1px solid ${colors.neutral90}` : undefined,
      borderRadius: '6px',
    }),
};
